import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, useWatch, Controller } from 'react-hook-form';
import { useContext, useEffect, useMemo, useRef } from 'react';
import {
  CommerciauxFiltersFormProps,
  CommerciauxFiltersFormSchema,
} from './CommerciauxFiltersForm.types';
import { getCommerciauxFilterSchema } from './CommerciauxFiltersForm.schema';
import { commerciauxFiltersFormData } from './CommerciauxFiltersForm.data';
import RSelect from 'react-select/dist/declarations/src/Select';
import Select from '../../../../../../commons/Select/Select';
import { ButtonColor, ButtonSize } from '../../../../../../designSystem/Button/Button.types';
import Button from '../../../../../../designSystem/Button/Button';
import { DashboardCommerciauxContext } from '../../DashboardCommerciaux.context';
import { SelectOption } from '../../../../../../commons/Select/Select.types';
import { CommercialEnabledFilters } from '../../DashboardCommerciaux.types';
import departments from '../../../../../../../assets/json/departements-region.json';

export default ({ closeModal }: CommerciauxFiltersFormProps) => {

  const { setFilters } = useContext(DashboardCommerciauxContext);

  const selectRefs = useRef<RSelect[]>([]);

  useEffect(() => {
    selectRefs.current = selectRefs.current.slice(0, [...Array(4)].length);
  }, []);

  const formProps = useForm<CommerciauxFiltersFormSchema>({
    resolver: yupResolver(getCommerciauxFilterSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    handleSubmit,
    control,
    setValue,
    formState: { isValid, errors },
  } = formProps;

  const region = useWatch({
    control,
    name: 'region',
  });

  const department = useWatch({
    control,
    name: 'department',
  });

  const isResetable = useMemo(() => Boolean(selectRefs), [selectRefs]);

  const onReinitialize = () => {
    selectRefs.current[1]?.clearValue()
    setValue('department', undefined)
    setValue('region', undefined)
    setFilters(undefined)
  };

  const onSubmit = handleSubmit(({ enabled, department }) => {
    setFilters({
      enabled: enabled ? (enabled as CommercialEnabledFilters) : CommercialEnabledFilters.LesDeux,
      department,
    });
    closeModal();
  });

  const updatedFormData = useMemo(
    () =>
      commerciauxFiltersFormData.map((row) =>
        row.map((item) => {
          switch (item.name) {
            case 'department':
              return {
                ...item,
                options: departments.map((dep) => ({
                  value: dep.dep_name,
                  label: dep.dep_name,
                })),
              };
            default:
              return item;
          }
        })
      ),
    [department, region]
  );

  return (
    <>
      <form className="form" style={{ width: 'calc(100% - var(--spacing-mToL) * 2)' }}>
        {updatedFormData.map((row, rowIndex) => (
          <div key={`row#${rowIndex}`} className="form__row">
            {row.map(({ name, placeholder, label, options, ...props }, inputIndex) => (
              <Controller
                key={`controlledInput#${inputIndex}`}
                name={name}
                render={({ field: { onChange } }) => (
                  <Select
                    ref={(ref) => (selectRefs.current[rowIndex] = ref)}
                    placeholder={placeholder || ''}
                    error={errors[name]?.message as string}
                    {...{ label, options }}
                    {...props}
                    // @ts-ignore
                    onChange={(arr: SelectOption | SelectOption[]) => {
                      if (arr && (arr as SelectOption[]).length) {
                        const values = (arr as SelectOption[]).map((item) => {
                          if (typeof item === 'string') {
                            return item;
                          } else {
                            return item.value;
                          }
                        });
                        onChange(values);
                      } else if (arr) {
                        onChange((arr as SelectOption).value);
                      }
                    }}
                  />
                )}
                {...{ control }}
              />
            ))}
          </div>
        ))}
        {isResetable && (
          <Button
            style={{ alignSelf: 'unset' }}
            onClick={(e) => {
              e.preventDefault();
              onReinitialize();
            }}
            size={ButtonSize.Large}
            color={ButtonColor.Contrast}>
            Réinitialiser
          </Button>
        )}
        <Button
          style={{ alignSelf: 'unset' }}
          onClick={(e) => {
            e.preventDefault();
            // setPaymentModalOpen(true);
            onSubmit();
          }}
          size={ButtonSize.Large}
          disabled={!isValid}>
          Appliquer
        </Button>
      </form>
    </>
  );
};
